<template>
  <!-- 下載 App 資訊 -->
  <v-sheet class="order-content__block guide-download-content pb-0 p-sm-5 pb-sm-5 !sm:wd-px-5" color="orange10" elevation="0" rounded>
    <div class="guide-download-content--wrapper wd-flex wd-justify-center wd-items-center flex-wrap flex-sm-nowrap" :class="wrapperClass">
      <div class="guide-download-content--left wd-w-full" :class="isElitePage && 'wd-w-100'">
        <p class="content-text wd-px-5 wd-text-orange50 sm:(wd-px-0)" :class="isElitePage ? 'wd-text-olg wd-leading-6 !wd-mb-3' : '!wd-mb-2'">
          <span>{{ downloadPromoText }}</span>
          <template v-if="!isElitePage">
            <br />
            <span>{{ $t('app_download_message') }}</span>
          </template>
        </p>

        <div class="image-row wd-flex wd-flex-wrap wd-px-5 sm:(wd-px-0)" :class="buttonWrapperClass" @click="guideDownloadApp">
          <v-img
            class="download-btn mr-2"
            src="@/assets/images/appdownload/atoms-web-download-appstore.svg?url"
            :max-width="downloadingImgMaxWidth"
            cover
          />
          <v-img
            class="download-btn"
            src="@/assets/images/appdownload/atoms-web-download-googleplay.svg?url"
            :max-width="downloadingImgMaxWidth"
            cover
          />
        </div>
      </div>

      <div class="guide-download-content--right wd-w-full wd-flex wd-justify-center" :class="imgWrapperClass">
        <v-img src="@/assets/images/funnow/funnow-gift.svg?url" />
      </div>
    </div>
  </v-sheet>
</template>

<script>
import { useVuetify } from '@/composition/useUtil'
import { useNewUserGift } from '@/composition/useNewUserGift'

export default defineComponent({
  props: {
    wrapperClass: { type: String, default: 'justify-center justify-sm-space-between' },
    isElitePage: { type: Boolean, default: false },
  },
  setup(props) {
    const config = useRuntimeConfig()
    const { downloadPromoText } = useNewUserGift(props.isElitePage ? 'elite' : '')
    const vuetify = useVuetify()
    const isSmAndUp = computed(() => vuetify.display.smAndUp.value)
    const buttonWrapperClass = computed(() => {
      return props.isElitePage && isSmAndUp.value ? 'wd-justify-start' : 'wd-justify-center'
    })
    const downloadingImgMaxWidth = computed(() => (props.isElitePage ? '137' : '164'))
    const imgWrapperClass = computed(() => {
      return props.isElitePage ? (isSmAndUp.value ? 'wd-pl-3 wd-max-w-40' : 'wd-mt-3 wd-max-w-80') : 'wd-mt-3 wd-pl-0 xs:(wd-pl-7) wd-max-w-50'
    })
    const imgMaxWidth = computed(() => {
      return props.isElitePage ? 200 : isSmAndUp.value ? 160 : 320
    })

    function guideDownloadApp() {
      location.href = `${config.public.BASE_URL}/app`
    }

    return {
      downloadPromoText,
      guideDownloadApp,
      buttonWrapperClass,
      downloadingImgMaxWidth,
      imgWrapperClass,
      imgMaxWidth,
    }
  },
})
</script>

<!-- TODO: use another way to style -->
<style lang="scss" src="@/assets/sass/pages/order-detail-page.scss"></style>
